export enum ChannelName {
  PUBLIC = 'public-channel',
  PRIVATE = 'private-channel',
}

export enum EventName {
  PUBLIC = 'public-event',
  PRIVATE = 'private-event',
}
